module.exports = __webpack_public_path__ + "img/AL291-2.d8374f10.jpg";